import {PackageInputProps} from './types';
import {useIntl} from "react-intl";
import Button from "@ui-components/Button";
import {useState} from "react";
import {useEffect} from "react";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import Spinner from "@ui-components/Spinner";

export const PackageInput = ({
  kColorProduct,
  selectableOptions,
  productPackage,
  setProductPackage,
  disabled=false,
  color
}: PackageInputProps) => {

  const intl = useIntl();
  // const options = unselectableOptions !== "__all__"
  //   ? kColorProduct.lst_min_qty.filter((q) => !unselectableOptions.includes(q))
  //   : kColorProduct.lst_min_qty;
  const [options, setOptions] = useState<number[] | undefined>();
  const countryApiRequest = useCountryAxiosInstance();

  const fetchPackages = async () => {
    if (kColorProduct && color) {
      const response = await countryApiRequest!.post("/kcolors/retrieve_packages", {
        cod_prod_comm: kColorProduct.cod_prod_comm,
        color_code: color.code
      }, {publicRequest: true});

      if (response) {
        const availablePackages: number[] = response.map((pkg: any) => pkg);

        const filteredOptions = selectableOptions !== "__all__"
          ? availablePackages.filter((q: number) => selectableOptions.includes(q))
          : availablePackages;
        setOptions(filteredOptions);
        // if the current selected package is no longer available put it to undefined
        if (productPackage && !filteredOptions.includes(productPackage)) {
          setProductPackage(undefined);
        }
        if (filteredOptions.length === 1){
          setProductPackage(filteredOptions[0])
        }
      }
    }
  }

  useEffect(() => {
    fetchPackages();
  }, [kColorProduct, color, selectableOptions]);

  if (!kColorProduct) return null;

  return <>
  {options?<><p className="font-bold">
      {intl.formatMessage({id: "package_format_label", defaultMessage: "Formato confezione di acquisto"})}
    </p>
    <div className={"flex items-left py-2 mt-3 flex-wrap"}>
      {!options.length && (
        <p className="italic text-gray-500">
          {intl.formatMessage({id: "no_package_options_available", defaultMessage: "Nessun confezionamento disponibile per questa combinazione di prodotto-colore"})}
        </p>
      )}
      {options.map((option: number) => (
        <Button
          key={option}
          onClick={() => {
            if (!!disabled) return;
            setProductPackage(option);
          }}
          className="py-2 px-4 mr-4 mb-2"
          styleType={productPackage === option ? "default" : "empty"}
          disabled={disabled}
        >
          {option} {kColorProduct.base_um}
        </Button>
        ))}
    </div>
  </>:<div className={"relative"}><Spinner styletype={"white"}/></div>}
  </>
}